import { i as d, c as v } from "../lit-element-8JrrHldg.js";
import { w as p } from "../chunk.CCJUT23E-JJ_URTr3.js";
import { c as h } from "../chunk.TUVJKY7S-CZwfrQkU.js";
import { a as n, S as m } from "../chunk.UYAO2JRR-CUGf3xdB.js";
import { n as f } from "../property-4FoNj0Pi.js";
var u = d`
  :host {
    --color: var(--sl-panel-border-color);
    --width: var(--sl-panel-border-width);
    --spacing: var(--sl-spacing-medium);
  }

  :host(:not([vertical])) {
    display: block;
    border-top: solid var(--width) var(--color);
    margin: var(--spacing) 0;
  }

  :host([vertical]) {
    display: inline-block;
    height: 100%;
    border-left: solid var(--width) var(--color);
    margin: 0 var(--spacing);
  }
`, r = class extends m {
  constructor() {
    super(...arguments), this.vertical = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("role", "separator");
  }
  handleVerticalChange() {
    this.setAttribute("aria-orientation", this.vertical ? "vertical" : "horizontal");
  }
};
r.styles = [h, u];
n([
  f({ type: Boolean, reflect: !0 })
], r.prototype, "vertical", 2);
n([
  p("vertical")
], r.prototype, "handleVerticalChange", 1);
var _ = r;
r.define("sl-divider");
var b = Object.defineProperty, g = Object.getOwnPropertyDescriptor, w = (s, t, i, a) => {
  for (var e = a > 1 ? void 0 : a ? g(t, i) : t, l = s.length - 1, o; l >= 0; l--)
    (o = s[l]) && (e = (a ? o(t, i, e) : o(e)) || e);
  return a && e && b(t, i, e), e;
};
let c = class extends _ {
};
c = w([
  v("pwc-divider")
], c);
export {
  c as PwcDivider
};
